// 下記2テーブルのマスタ値と連動しているため、
// マスタ変更時にはこちらにも修正が必要
// - m_offer_edit_boss_examination_status
const CLIENT_JOB_EDIT_STATUS_CODE = {
  DEFAULT: 'DEFAULT', // デフォルト
  EDITING: 'EDITING', // 編集中
  UNDER_REVIEW: 'UNDER_REVIEW', // 審査中
  APPROVED: 'APPROVED' // 承認済み
}

const BASE_CLIENT_JOB_EDIT_STATUS_UI = {
  showConfirmMessageArea: true,
  showUnderReviewTooltip: false,
  isDisabledRequestExaminationButton: false,
  showApprovalArea: false
}

const clientJobEditStatusUiVariation = {
  [CLIENT_JOB_EDIT_STATUS_CODE.DEFAULT]: BASE_CLIENT_JOB_EDIT_STATUS_UI,
  [CLIENT_JOB_EDIT_STATUS_CODE.EDITING]: {
    ...BASE_CLIENT_JOB_EDIT_STATUS_UI
  },
  [CLIENT_JOB_EDIT_STATUS_CODE.UNDER_REVIEW]: {
    ...BASE_CLIENT_JOB_EDIT_STATUS_UI,
    showConfirmMessageArea: false,
    showUnderReviewTooltip: true,
    isDisabledRequestExaminationButton: true,
    showApprovalArea: true
  },
  [CLIENT_JOB_EDIT_STATUS_CODE.APPROVED]: {
    ...BASE_CLIENT_JOB_EDIT_STATUS_UI
  }
}

export const getClientJobEditStatusUiVariation = (code) => {
  return clientJobEditStatusUiVariation[code] ?? BASE_CLIENT_JOB_EDIT_STATUS_UI
}
